import React, { createContext, useState } from 'react';

export const InvoiceContext = createContext();

export const InvoiceProvider = ({ children }) => {
  // Initialize selectedItems array
  const [selectedItems, setSelectedItems] = useState([]);
  
  // Initialize additionalNotes
  const [additionalNotes, setAdditionalNotes] = useState('');
  
  // Initialize selectedCreditNotes array
  const [selectedCreditNotes, setSelectedCreditNotes] = useState([]);

  const [InvoiceData, setInvoiceData] = useState({
    date: '',
    refNo: '',
    to: '',
    shipTo: '',
    additionalNotes: '',
    items: []
  });

  
  const [invoices, setInvoices] = useState([]);

  // ADDED: State to hold the temporary invoice form draft data
  const [invoiceDraft, setInvoiceDraft] = useState(null);

  // Function to add a new invoice
  const addInvoice = (invoice) => {
    setInvoices(prev => [...prev, invoice]);
  // Clear the form data after adding invoices
    setSelectedItems([]);
    setAdditionalNotes('');
    setSelectedCreditNotes([]);
    setInvoiceData({
      date: '',
      refNo: '',
      to: '',
      shipTo: '',
      additionalNotes: '',
      items: []
    });
  };

  return (
    <InvoiceContext.Provider value={{
      selectedItems,
      setSelectedItems,
      additionalNotes,
      setAdditionalNotes,
      selectedCreditNotes,
      setSelectedCreditNotes,
      InvoiceData,
      setInvoiceData,
      invoices,
      setInvoices,
      addInvoice,
      // ADDED: Expose the invoice draft state and its setter function
      invoiceDraft,
      setInvoiceDraft
    }}>
      {children}
    </InvoiceContext.Provider>
  );
};

export default InvoiceProvider;